import { List, Map, Record } from 'immutable';

export default Record({
    campaignId: '',
    fields: Map({
        asin: '',
        brand: '',
        ean: '',
    }),
    queries: List(['']),
    url: '',
});



// WEBPACK FOOTER //
// ./src/records/boost.js